var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('NiceButton',{staticClass:"breakdance-trigger-action-button",attrs:{"right-icon":_vm.options && _vm.options.icon},on:{"click":_vm.triggerOnPropertyChangeAction}},[_vm._v(" "+_vm._s(_vm.options.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }